<div
  (click)="sort()"
  [ngClass]="{ 'nf-can-sort': enableSorting }"
  class="lt-header-container"
  id="TableHeaderContainer_{{ column.key }}"
>
  <div class="lt-header-label">
    <span
      [title]="column.label || null"
      class="lt-header-text"
      [class.is-sorted]="sortDir === 'asc' || sortDir === 'desc'"
      id="HeaderName_{{ column.key }}"
      unselectable="on"
    >{{ column.label }}</span>
    @if (enableSorting) {
      <span class="lt-sort" [class.asc]="sortDir === 'asc'" [class.desc]="sortDir === 'desc'">
        <svg viewBox="0 0 8 14" width="8" height="13" aria-hidden="true">
          <path class="lt-sort-up" d="M4 0 7.5 4.5H0.5z"/>
          <path class="lt-sort-down" d="M4 14 0.5 9.5H7.5z"/>
        </svg>
      </span>
    }
  </div>
</div>
